import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import Registrations from "../../Registrations";
import Clients from "../../Clients";
import ProcessZuora from "../../../commonComponents/ProcessZuora";
import RegistrationStepsRoute from "../../RegistrationStepsRoute";

import { inject } from "mobx-react";

@inject("usersStore")
class Page extends Component {
  render() {
    return (
      <Switch>
        <Redirect from="/" exact to="/registrations" />
        <Route path="/registrations" component={Registrations} />
        <Route path="/clients" component={Clients} />
        <Route path="/reports" component={Registrations} />
        <Route path="/process-zuora" component={ProcessZuora} />
        <RegistrationStepsRoute />
      </Switch>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/App/Page/Page.js